import { render, staticRenderFns } from "./custom-type3.vue?vue&type=template&id=d74673c0&scoped=true"
import script from "./custom-type3.vue?vue&type=script&lang=js"
export * from "./custom-type3.vue?vue&type=script&lang=js"
import style0 from "./custom-type3.vue?vue&type=style&index=0&id=d74673c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74673c0",
  null
  
)

export default component.exports